import { BaseModel } from "@blue-chip/core";

export default class Product extends BaseModel {}
